// extracted by mini-css-extract-plugin
export default {"container":"TagContainer_container__fhsLj","tag":"TagContainer_tag__gIxf+"};